import { ReactElement } from 'react';
import { useTranslation } from 'next-i18next';
import { useWindowSize } from '@Hotels-at-Home/hah-fe-core/dist/hooks';
import { MD_WIDTH } from '@Hotels-at-Home/hah-fe-core/dist/constants';
import HomeStack from '~/ui/pages/Home/common/HomeStack';

const BathBodySection = (): ReactElement => {
  const { t } = useTranslation('', { keyPrefix: '$pages.$home.$bathBodySection' });
  const { t: tLink } = useTranslation('', {
    keyPrefix: '$local.$homePageLinks.$bathBodySection',
  });

  const windowSize = useWindowSize();
  const isSmallScreen = Boolean(windowSize.width) && windowSize.width <= MD_WIDTH;

  return (
    <section className="hp-section bath-body-section" id="hp-bath-body">
      <div className="bath-body-section-container">
        <HomeStack
          title={t('heading')}
          description={t('description')}
          img="/images/homePage/bathBodySection/pullman-bath-body.webp"
          imgMobile="/images/homePage/bathBodySection/pullman-bath-body-mob.webp"
          url={tLink('bath-body-section')}
          loading="eager"
        />
      </div>
    </section>
  );
};

export default BathBodySection;
